import { render, staticRenderFns } from "./restaurant-statistics.vue?vue&type=template&id=1ee8fa84&scoped=true&"
import script from "./restaurant-statistics.vue?vue&type=script&lang=js&"
export * from "./restaurant-statistics.vue?vue&type=script&lang=js&"
import style0 from "./restaurant-statistics.vue?vue&type=style&index=0&id=1ee8fa84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee8fa84",
  null
  
)

export default component.exports